import $, { type } from "jquery";
import CommonService from "./common.service";
import DashboardService from "../dashboard.service"; 
import SymbolService from "../symbol.service";
import ProfileService from "./profile.service";
import ScatterService from "./scatter.service";
import SurveyService from "../survey.service";
class MoneyballStickService {
    getColor(){
      return [
        "#000",
        "#7F7F7F",
        "#5886D4",
      ]
    }
    getGridForMoneyRank(top=ProfileService.getBaseGridTop(),bottom = '2.5%',includeBackgroud = true){
      let grid1 = {
        top:top,
        width: 670,
        containLabel: true,
        height: 640,
        left: 90,
        //bottom: bottom,
      };
      if (includeBackgroud == true){
          $.extend(true, grid1, ScatterService.getGridBackground());
      }
      return grid1;      
    }
    addGrid(currentTop){
      let grid = this.getGridForMoneyRank();
      if (grid.length > 0){
        grid[0].top += currentTop;
        grid[0].top += 10;
      }
      return grid[0];
    }
    getLegend(legendData){
      return {
        show: true,
        textStyle: {
          color: "#000",
          fontSize: 11,
          fontFamily: "Franklin Gothic Demi Cond"
        },
        borderColor: "#BFBFBF",
        width: "100%",
        orient: "vertical",
        itemWidth: 15,
        left: 3,
        top: 10,
        borderWidth: 0,
        data: legendData,
      };
    }
    getTooltip(){
      return {
        axisPointer: {
          type: "shadow"
        },
        trigger: "axis",
        textStyle: {
          color: "#000",
          fontSize: 11,
          fontFamily: "Franklin Gothic Medium Cond"
        },
        backgroundColor: "#ffffff",
        formatter: this.toolTipForMoneyballStick
      }      
    }
    getXAxis(xAxisData,rotate = 25,gridIndex= 0){
      return {
        type: "category",
        data: xAxisData,
        axisLabel: {
          rotate: rotate,
          fontFamily: "Franklin Gothic Demi Cond",
          fontSize: 10,
          //interval: 0
        },
        axisTick: {
          show: false
        },
        axisLine: {
          show: false
        }, 
        gridIndex: gridIndex,          
      }
    }
    getYAxisGroup(ySeries1,ySeries2,ySeries3,interval = 1,isDashboardCard = false){
      let yAxis = [];
      yAxis.push(ySeries1);
      yAxis.push(ySeries2);
      yAxis.push(ySeries3);
    
      $.extend(true, yAxis[0], this.getBaseYSeries(true));
      $.extend(true, yAxis[1], this.getBaseYSeries());
      $.extend(true, yAxis[2], this.getBaseYSeries(!isDashboardCard));
      if (isDashboardCard == false){
        yAxis[2].axisLabel.formatter =  "{value}%";
      }
      yAxis[0].splitNumber =  10;
      $.extend(true, yAxis[2],  this.getSplitLine(interval));
      yAxis[2].show = true;
      return yAxis;
    }
    getYAxis(maxYAxis,maxPricingPower,isDashboardCard,finalGridData={}){
      let returnYAxis = [];
      let baseYSeries1 = {
        min: 1,
        max: maxYAxis,
        gridIndex: 0,
        splitNumber: 1,
        splitLine: {
          lineStyle: {
            color: DashboardService.getBaseLineColor(),
            width: DashboardService.getBaseLineWidth()
          }
        },
      };
      let baseYSeries2 = {
        min: 1,
        max: 10,
        gridIndex: 0,
      };          
      let baseYSeries3 = {
        min: 0,
        max: maxPricingPower,
        gridIndex: 0,
      }; 
      let interval = 1;
      if (!$.isEmptyObject(finalGridData)) {         
        for (let i = 0; i < finalGridData.length; i++) {
          let ySeries1 = JSON.parse(JSON.stringify(baseYSeries1));
          let ySeries2 = JSON.parse(JSON.stringify(baseYSeries2));
          let ySeries3 = JSON.parse(JSON.stringify(baseYSeries3));
          let gridData = finalGridData[i];
          let letGridIndexSetting = (i != 0) ? {gridIndex: gridData.gridIndex} : {gridIndex: 0};
          $.extend(true, ySeries1, letGridIndexSetting);
          $.extend(true, ySeries2, letGridIndexSetting);
          $.extend(true, ySeries3, letGridIndexSetting);

          if (maxPricingPower > 50){
            interval = 5
          } else if (maxPricingPower > 20 && maxPricingPower <= 50){
            interval = 4
          } else if (maxPricingPower <= 20){
            interval = 2
          } 
    
          let yAxis = this.getYAxisGroup(ySeries1,ySeries2,ySeries3,interval,isDashboardCard);
          for (let i = 0; i < yAxis.length; i++) {
            returnYAxis.push(yAxis[i]);
          }
        }
      } else {
          let yAxis = this.getYAxisGroup(baseYSeries1,baseYSeries2,baseYSeries3,interval,isDashboardCard);
          for (let i = 0; i < yAxis.length; i++) {
            returnYAxis.push(yAxis[i]);
          }
      }
      return returnYAxis;
    }
    getGrid(width = 200){
      return [
        {
          left: 140,
          top: 10,
          width: width,
          containLabel: false,
          bottom: "20%",
          backgroundColor: "#F8F8F8",
          show: true
        }    
      ]
    }
    setDottedLine(minValueGapAvgMapped,i,xAxisLabel,importanceAvgData,xAxisIndex = 0,yAxisIndex = 1,gridIndex = 0){
        return {
          name: `Dotted Line Connecting Points - ${xAxisLabel}`,
          type: "line",
          data: [
            [i, minValueGapAvgMapped], // From: Mapped minimum value of Satisfaction Gap Avg or Emotions Gap Avg
            [i, importanceAvgData]  // Till: Importance Avg value
          ],
          lineStyle: {
            type: "dashed",
            color: "#898d7c",
            width: 1,
            dashOffset: 10,
          },
          symbol: "none", // No symbol at the start or end
          showSymbol: false,
          animation: false,
          gridIndex: gridIndex,
          xAxisIndex: xAxisIndex,
          yAxisIndex: yAxisIndex,
          markPoint: {
            data: [
              {
                type: "max", 
                symbol: "path://M2764.445557,2067.554443   C2792.991211,2096.100098 2821.031494,2124.151611 2849.084229,2152.190186   C2977.541260,2280.582275 3105.968262,2409.004395 3234.500977,2537.320801   C3252.414307,2555.204102 3271.194580,2572.227051 3288.908691,2590.299561   C3297.719482,2599.288574 3306.031006,2609.104492 3312.837402,2619.662598   C3345.302490,2670.021729 3337.085938,2736.779053 3296.526855,2779.068604   C3251.917725,2825.580566 3166.793701,2835.785156 3110.608887,2779.548340   C2996.828857,2665.663818 2882.900146,2551.927734 2769.036621,2438.126465   C2739.333008,2408.439209 2709.696045,2378.685059 2679.938965,2349.051270   C2544.628174,2214.301514 2409.244629,2079.624512 2273.971191,1944.837280   C2204.557373,1875.673218 2135.320312,1806.331909 2066.000244,1737.073975   C2051.909424,1722.996094 2051.986816,1723.088989 2037.946411,1736.908936   C2012.312256,1762.141113 1986.342529,1787.036255 1960.926270,1812.484863   C1930.807983,1842.641235 1901.395020,1873.503174 1871.208496,1903.589722   C1757.200195,2017.220459 1642.973267,2130.631592 1528.914062,2244.211182   C1515.698608,2257.371338 1503.178101,2271.227783 1490.036255,2284.464355   C1482.063477,2292.494141 1473.268066,2299.705566 1465.262573,2307.705566   C1354.691162,2418.199951 1244.288696,2528.864014 1133.631470,2639.272705   C1085.040039,2687.755127 1036.792603,2736.631592 986.836487,2783.680664   C949.776978,2818.583740 904.716858,2827.149170 856.694824,2810.704102   C801.419373,2791.775146 768.300842,2741.998047 770.121277,2683.666504   C771.151367,2650.660400 783.340942,2621.955322 806.615723,2598.401123   C834.726685,2569.952637 863.218506,2541.880859 891.499023,2513.599365   C1014.285034,2390.808350 1136.930542,2267.876953 1259.862671,2145.232666   C1393.635620,2011.772827 1527.733765,1878.639282 1661.566895,1745.239746   C1759.059448,1648.062866 1856.337402,1550.671143 1953.745728,1453.409790   C1972.992432,1434.192261 1995.167603,1419.716919 2022.121582,1414.092163   C2068.945557,1404.320923 2110.257568,1415.529541 2144.265869,1449.385986   C2247.723389,1552.381714 2350.707031,1655.853027 2454.088379,1758.925659   C2557.240234,1861.769409 2660.649414,1964.355103 2764.445557,2067.554443  z",  
                symbolSize: [10,7], 
                symbolOffset: [0,5],
                itemStyle: {
                  color: "#898d7c"
                },
                label: {
                  show: true,
                  position: 'top',
                  padding: -1,
                  textStyle: {
                    fontSize: 8,
                    fontWeight: "bold",
                    color: "#000",
                  }
                },
              }
            ]
          }
        };
    }
    getSplitLine(interval = 1){
      return {
        splitLine: {
          show: true,
          lineStyle: {
            color: "#C8C8C8",
            width: 0.25
          }
        },
        interval: interval
      }
    }  
    getWTPLabel(){
      return {
        label: {
          show: true,
          fontFamily: "Franklin Gothic Demi Cond",
          fontSize: 10,      
          position: 'insideBottom',
          color: "#000",
          formatter: function (params) {
            return params.value.toFixed(1)+'%'; // e.g., 3 ➝ 3.0
          }
        },        
      }       
    }
    getBaseYSeries(showLabel = false){
        return {
            type: "value",
            axisLabel: {
              show: showLabel,
              color: "#000",
              fontSize: 10.5,
              fontFamily: "Franklin Gothic Demi Cond",              
            },
            axisTick: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
          };
    }
    getBaseSeries(xAxisIndex = 0){
      return {
        type: "scatter", 
        label: {
          show: false,
        },
        emphasis: {
          disabled: true
        },
        animation: false,
        xAxisIndex: xAxisIndex	
      }  
    }
    getSeries(wtpData,importanceAvgData,satisfactionGapAvgData,emotionsGapAvgData,xAxisData,finalGridData={}){
      let returnSeries =  [];
      let xAxisIndex = 0;
      let yIndex = 0;
      let gridIndex = 0;
      let willingnessToPayYAxisIndex = yIndex + 2;
      let importanceAvgYAxisIndex = yIndex + 0;
      let satisfactionGapAvgYAxisIndex = yIndex + 1;
      let emotionsGapAvgYAxisIndex = yIndex + 1;
      let baseWtpSeries =  {
        name: SurveyService.getWTPLabel(),
        type: "bar",
        gridIndex: gridIndex,
        xAxisIndex: xAxisIndex,
        yAxisIndex: willingnessToPayYAxisIndex,
        data: wtpData,
        itemStyle: {
          color: "#D7E4BD"
        },
        barWidth: 35 // tk: comment this out to use the default bar width: moneyball stick project
      }
      let baseImportanceAvgSeries =  {
        name: "Importance Avg",
        gridIndex: gridIndex,
        xAxisIndex: xAxisIndex,
        yAxisIndex: importanceAvgYAxisIndex,
        data: importanceAvgData,
        symbol: SymbolService.getBarSymbol(),
        symbolSize: [21,4],
        zLevel: 10,
        z: 10
      }
      let baseSatisfactionGapAvgSeries = {
        name: "Satisfaction Gap Avg",
        gridIndex: gridIndex,
        xAxisIndex: xAxisIndex,
        yAxisIndex: satisfactionGapAvgYAxisIndex,
        data: satisfactionGapAvgData,
        symbol: SymbolService.getXSymbol(),
        symbolSize: 13,
        zLevel: 12,
        z: 12,
        lineStyle: {
          width: 5
        }
      }; 
      let baseEmotionsGapAvgSeries = {
        name: "Emotions Gap Avg",
        gridIndex: gridIndex,
        xAxisIndex: xAxisIndex,
        yAxisIndex: emotionsGapAvgYAxisIndex,
        data: emotionsGapAvgData,
        symbol: SymbolService.getXSymbol(),
        symbolSize: 13
      };

      if (!$.isEmptyObject(finalGridData)) {         
        for (let i = 0; i < finalGridData.length; i++) {
          let wtpSeries = JSON.parse(JSON.stringify(baseWtpSeries));
          let importanceAvgSeries = JSON.parse(JSON.stringify(baseImportanceAvgSeries));
          let satisfactionGapAvgSeries = JSON.parse(JSON.stringify(baseSatisfactionGapAvgSeries));
          let emotionsGapAvgSeries = JSON.parse(JSON.stringify(baseEmotionsGapAvgSeries));
          let gridData = finalGridData[i];
          wtpSeries.data = gridData.seriesData.wtpData;
          importanceAvgSeries.data = gridData.seriesData.importanceAvgData;
          satisfactionGapAvgSeries.data = gridData.seriesData.satisfactionGapAvgData;
          emotionsGapAvgSeries.data = gridData.seriesData.emotionalGapAvgData;
          xAxisData = gridData.seriesData.xAxisData;
          xAxisIndex = gridData.xIndex;
          let seriesSetting = {
              gridIndex: gridData.gridIndex,
              xAxisIndex: gridData.xIndex,
          };
          willingnessToPayYAxisIndex = gridData.yIndex + 2;
          importanceAvgYAxisIndex = gridData.yIndex + 0;
          satisfactionGapAvgYAxisIndex = gridData.yIndex + 1;
          emotionsGapAvgYAxisIndex = gridData.yIndex + 1;
    
          let wtpSeriesSetting = JSON.parse(JSON.stringify(seriesSetting));
          let importanceAvgSeriesSetting = JSON.parse(JSON.stringify(seriesSetting));
          let satisfactionGapAvgSeriesSetting = JSON.parse(JSON.stringify(seriesSetting));
          let emotionsGapAvgSeriesSetting = JSON.parse(JSON.stringify(seriesSetting));
          $.extend(true, wtpSeries, wtpSeriesSetting);
          $.extend(true, importanceAvgSeries, importanceAvgSeriesSetting);
          $.extend(true, satisfactionGapAvgSeries, satisfactionGapAvgSeriesSetting);
          $.extend(true, emotionsGapAvgSeries, emotionsGapAvgSeriesSetting);

          $.extend(true, wtpSeries, {yAxisIndex: willingnessToPayYAxisIndex});
          $.extend(true, importanceAvgSeries, {yAxisIndex: importanceAvgYAxisIndex});
          $.extend(true, satisfactionGapAvgSeries, {yAxisIndex: satisfactionGapAvgYAxisIndex});
          $.extend(true, emotionsGapAvgSeries, {yAxisIndex: emotionsGapAvgYAxisIndex});

          let series = this.getSeriesGroup(wtpSeries,importanceAvgSeries,satisfactionGapAvgSeries,emotionsGapAvgSeries,xAxisData);
          // Add the series to the returnSeries array
          for (let i = 0; i < series.length; i++) {
            returnSeries.push(series[i]);
          }
        }
      } else {
          let series = this.getSeriesGroup(baseWtpSeries,baseImportanceAvgSeries,baseSatisfactionGapAvgSeries,baseEmotionsGapAvgSeries,xAxisData);
          for (let i = 0; i < series.length; i++) {
            returnSeries.push(series[i]);
          }
      }      
      return returnSeries;
    }
    getSeriesGroup(wtpSeries,importanceAvgSeries,satisfactionGapAvgSeries,emotionsGapAvgSeries,xAxisData){
      let xAxisIndex = satisfactionGapAvgSeries.xAxisIndex;
      let yAxisIndex = satisfactionGapAvgSeries.yAxisIndex;
      let gridIndex = satisfactionGapAvgSeries.gridIndex;        
      let series =  [];
      let importanceAvgData = importanceAvgSeries.data
      let satisfactionGapAvgData = satisfactionGapAvgSeries.data;
      let emotionsGapAvgData=emotionsGapAvgSeries.data;
      series.push(wtpSeries);
      series.push(importanceAvgSeries);
      series.push(satisfactionGapAvgSeries);
      series.push(emotionsGapAvgSeries);
      $.extend(true, series[0], this.getBaseSeries(xAxisIndex));
      $.extend(true, series[1], this.getBaseSeries(xAxisIndex));
      $.extend(true, series[2], this.getBaseSeries(xAxisIndex));
      $.extend(true, series[3], this.getBaseSeries(xAxisIndex));
      $.extend(true, series[0], this.getWTPLabel());
      series[0].type = "bar";
      // Dynamically add the dotted lines
      let dottedLineSeries = [];
      for (let i = 0; i < xAxisData.length; i++) {
        let satisfactionGapAvg = satisfactionGapAvgData[i];
        let emotionsGapAvg = emotionsGapAvgData[i];
        let minValue = Math.min(satisfactionGapAvg, emotionsGapAvg);
        let dottedSeries = this.setDottedLine(minValue,i,xAxisData[i],importanceAvgData[i],xAxisIndex,yAxisIndex,gridIndex);
        dottedLineSeries.push(dottedSeries);
      }
      series.push(...dottedLineSeries);
      return series;
    }
    toolTipForMoneyballStick(params){
      let returnValue = "";
      let importanceAvgData = 0;
      for (let i = 0; i < params.length; ++i) {
        let seriesName = params[i].seriesName;
        if (seriesName.indexOf("Importance Avg") > -1){
          importanceAvgData =  params[i].data;
        }
      }      
      for (let i = 0; i < params.length; ++i) {
          let seriesName = params[i].seriesName;
          let displayPercent = (seriesName.indexOf(SurveyService.getWTPLabel()) > -1);
          if (seriesName.indexOf("Dotted Line Connecting Points") > -1){
            continue;
          }
          let valueToDisplay = params[i].value;
          if (seriesName.indexOf("Satisfaction Gap Avg") > -1 || seriesName.indexOf("Emotions Gap Avg") > -1){
            valueToDisplay = importanceAvgData - valueToDisplay;
            valueToDisplay = parseFloat(valueToDisplay.toFixed(2));
          }
          returnValue += params[i].marker += " ";
          returnValue += params[i].seriesName += " ";
          returnValue += "<span style='text-align:right'><b>" 
          if (valueToDisplay > 0){
              returnValue += valueToDisplay;
              if(displayPercent){
                returnValue += "%";
              }
          } else {
              returnValue += "--";
          }
          returnValue += "</b></span>";
          returnValue += "<br>";
      }
      return returnValue;
    }         
}
export default new MoneyballStickService();
